import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IRouteAlert } from '../../../../../interfaces/route-recommendations/route-alert';
import { RouteAlertName } from '../../../../../enums/route-alert-name.enum';
import { splitRouteAlertDescription } from '../../../../../utils/route-alert-utils';

@Component({
  selector: 'route-itinerary-alert',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './route-itinerary-alert.component.html',
  styleUrls: [
    './route-itinerary-alert.component.scss',
    '../../common/scss/route-itinerary-common.scss',
  ],
})
export class RouteItineraryAlertComponent {
  @Input() alerts: IRouteAlert[] = [];

  splitDescription = splitRouteAlertDescription;

  getIconClass(name: RouteAlertName): string {
    return name === RouteAlertName.Schedule ? 'fa-calendar' : 'fa-info-circle';
  }
}
